import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { CheckCircle2, LifeBuoy, Loader2 } from "lucide-react";

export const SupportOffer = ({ question, sessionId, page, onCreated, initialSent = false }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(question);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(initialSent);

  const send = async () => {
    if (text.trim().length < 3) { toast.error("Lütfen sorunuzu yazın"); return; }
    setBusy(true);
    try {
      await api.post("/support/tickets", { message: text.trim(), page, session_id: sessionId });
      setSent(true); toast.success("Destek talebiniz iletildi"); onCreated?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Talep gönderilemedi"); }
    finally { setBusy(false); }
  };

  if (sent) {
    return <p className="flex items-center gap-1.5 text-xs text-emerald-700" data-testid="support-offer-sent"><CheckCircle2 className="h-3.5 w-3.5" />Talebiniz iletildi. Cevap "Taleplerim" sekmesinde görünecek.</p>;
  }
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/70 p-3" data-testid="support-offer">
      {!open ? (
        <div className="flex items-center justify-between gap-2">
          <p className="text-xs text-amber-900">Bu sorunuzu destek ekibine ileteyim mi?</p>
          <Button size="sm" onClick={() => setOpen(true)} data-testid="support-offer-open" className="h-7 gap-1 bg-amber-500 hover:bg-amber-600 text-white text-xs"><LifeBuoy className="h-3.5 w-3.5" />Destek talebi oluştur</Button>
        </div>
      ) : (
        <div className="space-y-2">
          <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} maxLength={3000} data-testid="support-offer-text" className="text-sm bg-white" />
          <div className="flex justify-end gap-2">
            <Button size="sm" variant="ghost" onClick={() => setOpen(false)} className="h-7 text-xs">Vazgeç</Button>
            <Button size="sm" onClick={send} disabled={busy} data-testid="support-offer-send" className="h-7 text-xs bg-emerald-700 hover:bg-emerald-800 text-white">
              {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Gönder"}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
